import { useEffect, useState } from 'react';
import { addStage, delStage, listStages, renameStage, type Stage } from './deals-api';

// Настройка этапов воронки: переименование, добавить в конец, удалить последний.
export function StagesModal({
  onClose,
  onChanged,
}: {
  onClose: () => void;
  onChanged: () => void;
}) {
  const [stages, setStages] = useState<Stage[]>([]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const load = () => listStages().then((r) => setStages(r.stages));
  useEffect(() => {
    load();
  }, []);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function act(p: Promise<unknown>, err?: string) {
    setBusy(true);
    setMsg(null);
    try {
      await p;
      await load();
      onChanged();
    } catch {
      if (err) setMsg(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ovl" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 560 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-h">
          <div className="grow">
            <div className="m-cli">Этапы воронки</div>
            <div className="m-no">переименование · добавление · удаление</div>
          </div>
          <button className="icon-btn close-x" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="mbody">
          {msg && <p className="err">{msg}</p>}
          {stages.map((s) => (
            <div className="row" key={s.seq}>
              <div className="mono muted" style={{ width: 22 }}>
                {s.seq + 1}
              </div>
              <input
                className="grow"
                defaultValue={s.name}
                disabled={busy}
                onBlur={(e) =>
                  e.target.value.trim() &&
                  e.target.value !== s.name &&
                  act(renameStage(s.seq, e.target.value.trim()))
                }
              />
              {s.is_production === 1 && <span className="chip vi">производство</span>}
              {s.seq === stages.length - 1 && stages.length > 1 && s.is_production !== 1 && (
                <button
                  className="icon-btn"
                  disabled={busy}
                  title="Удалить последний этап"
                  onClick={() => act(delStage(s.seq), 'Нельзя удалить: в этапе есть сделки.')}
                >
                  🗑
                </button>
              )}
            </div>
          ))}
          <div style={{ marginTop: 12 }}>
            <button
              className="btn ghost sm"
              disabled={busy}
              onClick={() => act(addStage('Новый этап'))}
            >
              + Добавить этап
            </button>
          </div>
          <p className="muted small" style={{ marginTop: 12 }}>
            Изменение имени применяется сразу. Удалять можно только последний этап и только если в
            нём нет сделок.
          </p>
        </div>
      </div>
    </div>
  );
}
